/* eslint-disable */
import { GetCustomerEligiblePromotion, GetCustomerLoyaltyProgram } from '../api/user';
import { AddedItemPricing, AgreementRateTerm, CustomerEligiblePromotionsRequest, RmsItemInformation } from './rewardsUtilsInterface';
import { PROMOTION_LOB, CHANNEL } from '../constants/constants';

export const CustomerLoyaltyProgram = async (gcid: any) => {
    try {
        const loyaltyResponse: any = await GetCustomerLoyaltyProgram(gcid)

        const result = {
            loyaltyProgram: loyaltyResponse?.data || null,
            eligiblePromotions: null,
            customerTierCodes: null
        };

        const memberStatus:string = loyaltyResponse?.data?.memberStatus
        const storeNumber: string | null = sessionStorage.getItem('storeNumber');

        if (loyaltyResponse?.status === 200 && memberStatus == 'Active') {
            const payload: CustomerEligiblePromotionsRequest = {
                storeNumber: storeNumber,
                channel: CHANNEL,
                lob: PROMOTION_LOB,
                customer: {
                    globalCustomerId: gcid,
                    tier: loyaltyResponse?.data?.memberTiers?.loyaltyMemberTier
                }
            };
            const promotionResponse = await GetCustomerEligiblePromotion(payload);
            result.eligiblePromotions = promotionResponse?.data?.promotions || null;
            result.customerTierCodes = promotionResponse?.data?.CustomerTierCodes || null;

        }
        console.log(result, "customer loyalty program response");
        return result;
    } catch (error) {
        console.log("Error in REWARD APIS - ", error);
    }
}

export const extractRmsItemNumbers = (addedItem: any) => {
    if (!addedItem || !Array.isArray(addedItem.itemPricing) || addedItem.itemPricing.length === 0) {
        console.log("No items or itemPricing is empty");
        return [];
    }

    const allNumbers = addedItem.itemPricing
        .map(item => item?.rmsItemNumber)
        .filter(Boolean);

    const uniqueNumbers = [...new Set(allNumbers)];

    console.log("Extracted unique rmsItemNumbers:", uniqueNumbers);
    return uniqueNumbers;
};

export const extractInventoryNumber = (addedItem: any) => {
    if (!addedItem || !Array.isArray(addedItem.itemPricing) || addedItem.itemPricing.length === 0) {
        console.log("No items or itemPricing is empty");
        return [];
    }

    const allNumbers = addedItem.itemPricing
        .map(item => item?.inventoryNumber)
        .filter(Boolean);

    const uniqueNumbers = [...new Set(allNumbers)];

    console.log("Extracted unique InventoryNumbers:", uniqueNumbers);
    return uniqueNumbers;
};

/**
 * Maps the agreement rate/term details from the GetItemPricing (package-item price)
 * response - used in the Rental Agreement flow - to the agreementRateTerm shape
 * expected by GetCustomerEligiblePromotions. Only fields that actually exist on the
 * GetItemPricing response are mapped; the rest are left undefined.
 */
export const mapRateTermFromItemPricing = (addedItem: AddedItemPricing): AgreementRateTerm | undefined => {
    if (!addedItem || !addedItem.agreementPricing) {
        console.log("No addedItem or agreementPricing is empty");
        return undefined;
    }

    const agreementPricing = addedItem.agreementPricing;

    const agreementRateTerm: AgreementRateTerm = {
        // weeklyRate/weeklyTerm carry the same values mapped to agreementRate/agreementTerm.
        weeklyRate: agreementPricing?.agreementRate ?? undefined,
        weeklyTerm: agreementPricing?.agreementTerm ?? undefined,
        agreementRate: agreementPricing?.agreementRate ?? undefined,
        agreementTerm: agreementPricing?.agreementTerm ?? undefined,
        agreementTotal: agreementPricing?.agreementTotal ?? undefined,
        cashPrice: agreementPricing?.cashPrice ?? undefined,
        epoAmount: agreementPricing?.epoAmount ?? undefined
    };

    console.log("Extracted agreementRateTerm from item pricing:", agreementRateTerm);
    return agreementRateTerm;
};

/**
 * Maps the rate/term details from the customerOrderSearch / getProductAPI response
 * (rmsItemInformation) - used in the Customer Order flow - to the agreementRateTerm
 * shape expected by GetCustomerEligiblePromotions. Only fields that actually exist on
 * that response are mapped; the rest are left undefined.
 */
export const mapRateTermFromRmsItem = (rmsItemInformation: RmsItemInformation[]): AgreementRateTerm | undefined => {
    if (!Array.isArray(rmsItemInformation) || rmsItemInformation.length === 0) {
        console.log("No rmsItemInformation to extract agreementRateTerm from");
        return undefined;
    }

    const item = rmsItemInformation[0];

    const agreementRateTerm: AgreementRateTerm = {
        weeklyRate: item?.weeklyRate ?? undefined,
        weeklyTerm: item?.weeklyTerm != null ? String(item.weeklyTerm) : undefined,
        biWeeklyRate: item?.biWeeklyRate ?? undefined,
        biWeeklyTerm: item?.biWeeklyTerm != null ? String(item.biWeeklyTerm) : undefined,
        semiMonthlyRate: item?.semiMonthlyRate ?? undefined,
        semiMonthlyTerm: item?.semiMonthlyTerm != null ? String(item.semiMonthlyTerm) : undefined,
        monthlyRate: item?.monthlyRate ?? undefined,
        monthlyTerm: item?.monthlyTerm != null ? String(item.monthlyTerm) : undefined,
        // Customer Order flow has no agreement yet, so the weekly rate/term is used
        // as a stand-in for agreementRate/agreementTerm, and totalCost as agreementTotal.
        agreementRate: item?.weeklyRate ?? undefined,
        agreementTerm: item?.weeklyTerm != null ? String(item.weeklyTerm) : undefined,
        agreementTotal: item?.totalCost ?? undefined,
        cashPrice: item?.cashPrice ?? undefined
    };

    console.log("Extracted agreementRateTerm from rmsItemInformation:", agreementRateTerm);
    return agreementRateTerm;
};